import React from 'react';
import { mergeProps } from 'next-merge-props';

import { ILearningCenterArticle } from '@/types/contentful';

import { getServerSideArticleProps } from '../../../modules/learning-center/getServerSideArticleProps';
import { getServerSideCookieProps } from '../../../modules/cookies/getServerSideCookieProps';

import { PageProps } from '../../../context/PageData';

import { Body } from '../../../components/Body';
import { Article } from '../../../components/LearningCenter/Article';
import { PageBlocks } from '../../../components/Page/PageBlocks';

export interface ArticleProps extends PageProps {
  articleData: ILearningCenterArticle;
}

export default function ArticlePage({ articleData, query }: ArticleProps) {
  const { fields, sys } = articleData ?? {};
  const { slug } = fields?.category?.fields ?? {};

  return (
    <Body
      {...fields}
      query={query}
      pathPrefix={`/learning-center/${slug}`}
      bgColor="#F3F3F3"
    >
      <Article {...fields} sysId={sys?.id} />
      <PageBlocks {...fields} />
    </Body>
  );
}

export const getServerSideProps = mergeProps([
  getServerSideArticleProps,
  getServerSideCookieProps
]);
